export enum SignupSteps {
  EMAIL_AND_MOBILE = 1,
  REACH_US = 2,
  ACADEMY_INFO = 3
}
